 <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" id="common-dialog-wrapper" #wrapper></div>
